// in src/Dashboard.js
import React, { useState, useEffect } from 'react';

import axios from "axios";

import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@mui/material/Typography';

import IconCancel from '@material-ui/icons/Cancel';

import { apiUrl } from '../common/constants';

import Carousel from 'react-material-ui-carousel';

import TextField from '@mui/material/TextField';

import Paginador from './Paginador';

import { IconButton } from '@material-ui/core';

import { DateInput, useRefresh, useDataProvider, useNotify, useCreate, TextInput, NumberInput, FormWithRedirect, SaveButton } from 'react-admin';import { parse } from 'query-string';


import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { ArrowBack } from '@material-ui/icons';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { useTranslate, setAssociationLang, defaultLanguage } from '../common/language';import MyLoading from '../components/MyLoading';



import { dateEventByLang, timeEventByLang } from '../common/utils';
import { headersAPIObjectPublic } from '../common/utils';


import PlaceIcon from '@mui/icons-material/Place';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';





import { Form } from 'react-final-form';
import { useHistory, useLocation } from 'react-router-dom';

import Chip from '@material-ui/core/Chip';

const getPublicEventImageUrl = item => {
  if (!item || !item.images) return null;

  if (Array.isArray(item.images)) {
    if (!item.images.length) return null;
    return item.images[0];
  }

  if (typeof item.images === 'string') {
    return item.images;
  }

  return null;
};

const getPublicEventAddress = item => {
  return [
    item.classrooms_name,
    item.events_address || item.address,
    item.events_cities_name || item.cities_name
  ].filter(value => value != null && value.length > 0).join(', ');
};

const isPublicSessionInRange = (session, dateStartAfter, dateStartBefore) => {
  const sessionStart = new Date(session.start || session.date_start);
  const sessionEnd = new Date(session.end || session.date_finish || session.start || session.date_start);

  if (isNaN(sessionStart.getTime())) return false;

  const dateAfter = dateStartAfter != null && dateStartAfter.length > 0
    ? new Date(dateStartAfter + 'T00:00:00')
    : null;
  const dateBefore = dateStartBefore != null && dateStartBefore.length > 0
    ? new Date(dateStartBefore + 'T23:59:59')
    : null;

  return (!dateAfter || sessionEnd >= dateAfter) && (!dateBefore || sessionStart <= dateBefore);
};

const publicEventsToSessionCards = (events, dateStartAfter, dateStartBefore) => {
  return events.flatMap(event => {
    if (!Array.isArray(event.sessions) || !event.sessions.length) {
      return [event];
    }

    return event.sessions
      .filter(session => isPublicSessionInRange(session, dateStartAfter, dateStartBefore))
      .map(session => ({
        ...event,
        id: `${event.id}-${session.id}`,
        events_id: event.id,
        events_sessions_id: session.id,
        session_name: session.name,
        start: session.start || session.date_start,
        end: session.end || session.date_finish || session.start || session.date_start
      }));
  });
};

export const PublicEventsList = props => {
    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
    
  let history = useHistory();
  const location = useLocation();
    
  const searchParams = new URLSearchParams(location.search);    
  const { associations_id: associations_id_string } = parse(props.location.search);    
  const [page, setPage] = useState(searchParams.get('page') ? parseInt(searchParams.get('page')) : 1);
  const [search, setSearch] = useState(searchParams.get('search') ? searchParams.get('search') : '');    
  const [organizer, setOrganizer] = useState(searchParams.get('organizer') ? searchParams.get('organizer') : 0);    
  const [activity, setActivity] = useState(searchParams.get('activity') ? searchParams.get('activity') : 0);    
  const [category, setCategory] = useState(searchParams.get('category') ? searchParams.get('category') : 0);    
  const [province, setProvince] = useState(searchParams.get('province') ? searchParams.get('province') : 0);    
  const [region, setRegion] = useState(searchParams.get('region') ? searchParams.get('region') : 0);    
  const [city, setCity] = useState(searchParams.get('city') ? searchParams.get('city') : 0);    
  const [dateStartAfter, setDateStartAfter] = useState(searchParams.get('dateStartAfter') ? searchParams.get('dateStartAfter') : new Date().toISOString().slice(0, 10));
  const [dateStartBefore, setDateStartBefore] = useState(searchParams.get('dateStartBefore') ? searchParams.get('dateStartBefore') : null );
  const [info, setInfo] = useState();
  const [associationInfo, setAssociationInfo] = useState();
  const [events, setEvents] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);  
  const [categories, setCategories] = useState();
  const [organizers, setOrganizers] = useState();
  const [provinces, setProvinces] = useState();
  const [regions, setRegions] = useState();
  const [cities, setCities] = useState();
  
  const { friendly_url } = useParams();
        
  let events_fac = false;
  let events_facm = false;
  let associations_id = 0;
  let url = 'events/public/sessions';
  if ( associations_id_string && associations_id_string === 'fac')
  {
    url = 'events/public/sessions/fac';
    events_fac = true;
  }
  else if ( friendly_url && friendly_url.includes('caixa-manlleu'))
  {
    events_facm = true;
  }
  else
  {
    associations_id = associations_id_string ? parseInt(associations_id_string, 10) : 0;   
  }
          
  const updateUrl = (field,value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(field, value);
    if (field !== 'page') searchParams.set('page', 1);
    const newSearch = searchParams.toString();
    history.push({
      pathname: location.pathname,
      search: newSearch
    });
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
    updateUrl('page',newPage);
    window.scrollTo(0, 0);        
  };
    
  const handleSubmit = (values) => {
    
  };
        
  var today = new Date().toISOString().slice(0, 10);
    
  const perPage = 6;
  
  useEffect(() => {
      
      // L'agregació de la FAC en català. La resta mirem l'idioma de l'entitat
      if (events_fac) {
          setAssociationInfo( { lang : defaultLanguage } );
      }
      else
      {
        const urlAssociationInfo = 
            friendly_url
            ? `${apiUrl}/associations/public/str/${friendly_url}`
            : `${apiUrl}/associations/public/${associations_id}`;

        axios.get(urlAssociationInfo, { headers: headersAPIObjectPublic() } )
            .then((response) => {
                setAssociationInfo(response.data);                  
            })
            .catch((err) => {
                console.error(err);
                setError(true);
                setLoading(false);
            });
        }
    }, [friendly_url, associations_id]);

        
  useEffect(() => {      
      
     if (!associationInfo) return; // evitar cridar fins que tinguem idioma
     
     setAssociationLang(associationInfo.lang);  
          
     dataProvider.getList(url, {
        pagination: { page: 1, perPage: 1000000 },
        sort: { field: 'priority', order: 'ASC' },
        filter: { associations_id: associations_id, 
          friendly_url: friendly_url ? friendly_url : '',
          organizers_id: organizer, 
          search: search, 
          activities_id: activity, 
          categories_id: category, 
          start_gte : dateStartAfter != null && dateStartAfter.length > 0 ? dateStartAfter + 'T00:00:00' : '', 
          start_lte : dateStartBefore != null && dateStartBefore.length > 0? dateStartBefore + 'T23:59:59' : '',
          provinces_id: province,
          regions_id: region,
          cities_id: city,
        } 
      } )
        .then(response => {
          const sessionEvents = publicEventsToSessionCards(response.data, dateStartAfter, dateStartBefore);
          const start = (page - 1) * perPage;
          const end = start + perPage;
          setEvents(sessionEvents.slice(start, end));
          setInfo({ ...response, total: sessionEvents.length });
          setLoading(false);
          setError(false);
        })
        .catch(error => {        
          console.log(error);
          setLoading(false);  
          setError(true);
        });
                
        if (!categories) {
            axios.get(apiUrl + '/events/public/categories?context=' + (events_facm ? 1 : 0), { headers: headersAPIObjectPublic() } )
            .then(response => {                
                setCategories(Array.isArray(response.data) ? response.data : []);                
            })
            .catch(error => {   
                console.error(error);
                setCategories([]);
            });
        }
        
        if (!organizers)
        {
          dataProvider.getList('organizers/public', {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'name', order: 'ASC' },
            filter: { } } )
            .then(response => {                
              setOrganizers(response.data);                
            })
            .catch(error => {   
            });
        }

        if (!provinces)
        {
          dataProvider.getList('provinces', {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'priority', order: 'ASC' },
            filter: { } } )
            .then(response => {                
              setProvinces(response.data);                
            })
            .catch(error => {   
            });
        }
                            
  }, [ page, search, activity, category, dateStartAfter, dateStartBefore, organizer, province, region, city, associationInfo ]);
    
  useEffect(() => {
        
    setPage(1);  updateUrl('province',province);
        
    dataProvider.getList('regions', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'name', order: 'ASC' },
      filter: { provinces_id: province } } )
      .then(response => {                
        setRegions(response.data);            
        setRegion(0);
                        
        dataProvider.getList('cities', {
          pagination: { page: 1, perPage: 10000 },
          sort: { field: 'name', order: 'ASC' },
          filter: { regions_id: region, provinces_id: province } } )
          .then(response => {                
            setCities(response.data); 
            setCity(0);
          })
          .catch(error => {   
          });
      })
      .catch(error => {   
      });
        
  }, [ province ]);
    
  useEffect(() => {
        
    dataProvider.getList('cities', {
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'name', order: 'ASC' },
      filter: { regions_id: region, provinces_id: province } } )
      .then(response => {                
        setCities(response.data);   
        setCity(0);
    
        setPage(1);  
        updateUrl('region',region);
            
      })
      .catch(error => {   
      });
    
        
  }, [ region ]);
    
  useEffect(() => {        
    setPage(1);  updateUrl('city',city);
  }, [ city ]);
    
  if (loading) return <><br/><br/><br/><br/><MyLoading /></>;
  if (error) return (<center><br /><br/>{translate('public_events.association_not_found')}</center>);
        
  if (!events || !categories || !organizers || !provinces || !regions || !cities) return null;
                
  return (
    <Box sx={{ width: '95%', bgcolor: 'background.paper', padding: '1%' }} className="add_member_box" >
      <Grid container spacing={1}>
        <Grid item xs={12}>  
        </Grid>
      </Grid>   
            
      <Form initialValues={ {dateStartAfter: dateStartAfter, dateStartBefore: dateStartBefore}} onSubmit={handleSubmit} >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1} className="public-events-filter">
              <Grid item xs={12} md={2}>  
                <TextField value={search} source="search" className="public-events-filter-mt" fullWidth id="standard-basic" label={translate('public_events.search')} variant="standard" placeholder="" onChange={(event) => { setSearch(event.target.value); setPage(1); updateUrl('search',event.target.value); }}/>  
              </Grid>                                      
              <Grid item xs={6} md={2}>  
                <DateInput
                  source="dateStartAfter"
                  label={translate('public_events.filter_date_after')}
                  value={dateStartAfter}
                  onChange={(event) => { setDateStartAfter(event.target.value); setPage(1);  updateUrl('dateStartAfter',event.target.value); } }     
                  fullWidth
                  variant="standard"
                />
              </Grid>
              <Grid item xs={6} md={2}>  
                <DateInput
                  source="dateStartBefore"
                  label={translate('public_events.filter_date_before')}
                  value={dateStartBefore}
                  onChange={(event) => { setDateStartBefore(event.target.value); setPage(1);  updateUrl('dateStartBefore',event.target.value); } }   
                  fullWidth
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} md={3}>  
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard-categories"
                  value={category}
                  onChange={(event) => { setCategory(event.target.value); setPage(1);  updateUrl('category',event.target.value); }}
                  label={translate('events.categories')} 
                  fullWidth
                >
                  <MenuItem value="0">{translate('public_events.filter_category_all')} </MenuItem>
                  {categories.map((item) => (  
                    <MenuItem value={item.id}>{item.name}</MenuItem>
                  ))}                    
                </Select>
              </Grid>  
              { events_fac ? 
                <Grid item xs={12} sm={3}>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={organizer}
                    onChange={(event) => { setOrganizer(event.target.value); setPage(1);  updateUrl('organizer',event.target.value); }}
                    label={translate('public_events.filter_organizer')}   
                    fullWidth
                  >
                    <MenuItem value="0">{translate('public_events.filter_organizer_all')} </MenuItem>
                    {organizers.map((item) => (  
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}                    
                  </Select>
                </Grid> : null }
                        
              { events_fac ? 
                <Grid item xs={12} md={2}>  
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={province}
                    onChange={(event) => { setProvince(event.target.value); }}
                    label={translate('public_events.filter_province')} 
                    fullWidth
                  >
                    <MenuItem value="0">{translate('public_events.filter_province_all')} </MenuItem>
                    {provinces.map((item) => (  
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}                    
                  </Select>
                </Grid> : null }
                        
              { events_fac ? 
                <Grid item xs={12} md={3}>  
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={region}
                    onChange={(event) => { setRegion(event.target.value); }}
                    label={translate('public_events.filter_region')} 
                    fullWidth
                  >
                    <MenuItem value="0">{translate('public_events.filter_region_all')} </MenuItem>
                    {regions.map((item) => (  
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}                    
                  </Select>
                </Grid> : null }
                        
              { events_fac && (region > 0 || province > 0) ? 
                <Grid item xs={12} md={3}>  
                            
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={city}
                    onChange={(event) => { setCity(event.target.value); }}
                    label={translate('public_events.filter_city')} 
                    fullWidth
                  >
                    <MenuItem value="0">{translate('public_events.filter_city_all')} </MenuItem>
                    {cities.map((item) => (  
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}                    
                  </Select>
                            
                </Grid> : null }
                        
            </Grid> 
          </form>
        )}
      </Form>
                 
      <Paginador page={page} perPage={perPage} onPageChange={onPageChange} total={info.total} />
      <br /><br/>  
            
      <Grid container spacing={2}>
        {events.map((item) => {  
                        
          const address = getPublicEventAddress(item);
          const imageUrl = getPublicEventImageUrl(item);
    
          return (
            <Grid key={item.id} item xs={12} sm={6} lg={4} textAlign="left" className="classrooms_list_item_container">  
              <Card>                            
                            
                { imageUrl ?
                  <div title={item.title} className="public-events-img" style={{ backgroundImage: 'url("' + imageUrl + '")' }} />
                  : 
                  null
                }
                            
                <CardContent>
                            
                  {item.categories && item.categories.map(category => (
                    <Chip key={category.id} label={category.name} variant="outlined" className="bg-orange bc-orange upper mb-10 color-white text-align-left" style={{ marginRight: 3, marginBottom: 3 }} />
                  ))}
                  <Box display="flex" alignItems="center" className="mb-5">
                    <CalendarTodayIcon className="public-events-icon" />
                    <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                      {dateEventByLang(item.start,item.end,translate, associationInfo.lang)}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" className="mb-5">
                    <AccessTimeIcon className="public-events-icon" />
                    <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                      {timeEventByLang(item.start,translate, associationInfo.lang)}
                    </Typography>
                  </Box>

                  {item.session_name && item.session_name !== item.title ? 
                    <Typography color="text.secondary" align="justify" className="fs-12 mb-5">
                      {item.session_name}
                    </Typography> : null}
                            
                  {address.length > 0 ? 
                    <Box display="flex" alignItems="center" className="mb-5">
                      <PlaceIcon className="public-events-icon" />
                      <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                        {address}
                      </Typography>
                    </Box> : null } 
                                                        
                  <Box display="flex" alignItems="center" className="mb-10">
                    <CorporateFareIcon className="public-events-icon" />
                    <Typography color="text.secondary" align="justify" className="fs-12 ml-5 upper">
                      {item.organizers_name != null ? item.organizers_name : item.associations_name }  
                    </Typography>
                  </Box> 
                            
                  <a href={'/#/public/events/' + item.friendly_url} className="classrooms_list_item_link">
                    <Typography gutterBottom variant="h5" component="div" align="left" className="bold">
                      {item.title}
                    </Typography>
                  </a>
                  <Typography variant="body2" color="text.secondary" align="justify" className="public-events-description">
                    {item.description ? item.description.replace(/<[^>]*>/g, '') : null}
                  </Typography>                            
                </CardContent>
                <CardActions align="right">
                  <Box flexGrow={1} />
                  <a href={'/#/public/events/' + item.friendly_url} className="classrooms_list_item_link"><Button size="small">{translate('public_events.more_info')} </Button></a>
                  <TicketsButton tickets_url={item.tickets_url} />  
                </CardActions>
              </Card>
            </Grid>   
          );})}
      </Grid>
                        
      <Paginador page={page} perPage={perPage} onPageChange={onPageChange} total={info.total} />
                     
      <br /><br />
    </Box>
  );
};

export const TicketsButton = props => {

    const translate = useTranslate();  
    
    let show_tickets_url = props.tickets_url;
    if (show_tickets_url && !show_tickets_url.includes('//'))
    {
        show_tickets_url = 'https://' + show_tickets_url;
    }
    
    return (
        show_tickets_url ? <a href={show_tickets_url} target='_blank' className=""><Button size="small" variant="contained">{translate('public_events.tickets')} </Button></a> : null    
    );
}

export const TicketsButtonDemo = props => {

    const translate = useTranslate();  
    const [create] = useCreate('bookings/public');
    const [showDialog, setShowDialog] = useState(false);
    
    const handleClick = (id) => {    
        setShowDialog(true);      
    }
    const handleCloseClick = () => {
      setShowDialog(false);
    };

    const handleSubmit = async values => {
        create(
          { payload: { data: values } }, 
          {
            onSuccess: ({ data }) => {
              setShowDialog(false);
            },
            onFailure: (error) => {
              alert('Hi ha hagut un error...');
            }
          }
        );
    };
    
  
    return (
            <>
        <Button size="small" onClick={() => handleClick(props.events_id)}  variant="contained">{translate('public_events.buy_ticket')} </Button>   
        
        <Dialog
            fullWidth
            open={showDialog}
            onClose={handleCloseClick}
            aria-label={translate('public_events.buy_ticket')}
          >
            <DialogTitle>{translate('public_events.buy_ticket')}</DialogTitle>

            <FormWithRedirect
              resource="alerts"
              save={handleSubmit}
              initialValues={{ events_id: props.events_id, email: 'francesctomas@gmail.com', first_name: 'Francesc', last_name_1: 'Tomàs', quantity: 3 }}
              render={({
                handleSubmitWithRedirect,
                pristine,
                saving
              }) => (
                <>
                  <DialogContent>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>  
                        <TextInput fullWidth label={translate('users.first_name')} source="first_name" resettable />
                      </Grid> 
                      <Grid item xs={4}>  
                        <TextInput fullWidth label={translate('users.last_name_1')} source="last_name_1" resettable />
                      </Grid> 
                      <Grid item xs={4}>  
                        <TextInput fullWidth label={translate('users.last_name_2')} source="last_name_2" resettable />
                      </Grid> 
                    </Grid>  
                    <Grid container spacing={2}>
                      <Grid item xs={8}>  
                        <TextInput fullWidth label={translate('common.email')} source="email" resettable />
                      </Grid> 
                      <Grid item xs={4}>  
                        <NumberInput fullWidth label={translate('public_events.quantity')} source="quantity" resettable />
                      </Grid> 
                    </Grid>  
                  </DialogContent>
                  <DialogActions>
                    <Button label="ra.action.cancel" onClick={handleCloseClick} >
                      <IconCancel />
                    </Button>
                    <SaveButton
                      handleSubmitWithRedirect={
                        handleSubmitWithRedirect
                      }
                      pristine={pristine}
                      saving={saving}
                    />
                  </DialogActions>
                </>
              )}
            />
          </Dialog>
          </>    
    );
}


export const PublicEvent = props => {
    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
  const history = useHistory();
    
  const [info, setInfo] = useState();
  const [events, setEvents] = useState();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
    
  const { events_id: events_id_string } = parse(props.location.search);
  const events_id = events_id_string ? parseInt(events_id_string, 10) : '';
  
  const { friendly_url } = useParams();
    
  const backButtonClick = () => {        
    if (history.length > 2) 
    {
      history.goBack();
    }
    else if (info)
    {
        history.push('/public/events/list/' + info.friendly_url);
    }
  };
    
  useEffect(() => {
          
    let url = ''; 
    if (friendly_url)
        url = apiUrl + '/events/public/sessions/str/' + friendly_url;        
    else
        url = apiUrl + '/events/public/' + events_id;    
    
    axios.get(url, { headers: headersAPIObjectPublic() } )
    .then((response) => {
        setEvents(response.data);

        Promise.all([
          axios.get(apiUrl + '/events/public/categories?context=0', { headers: headersAPIObjectPublic() }),
          axios.get(apiUrl + '/events/public/categories?context=1', { headers: headersAPIObjectPublic() })
        ])
        .then(([context0, context1]) => {
          setCategories([
            ...(Array.isArray(context0.data) ? context0.data : []),
            ...(Array.isArray(context1.data) ? context1.data : [])
          ]);
        })
        .catch(() => {
          setCategories([]);
        });
        
        dataProvider.getOne('associations/public', { id: response.data.associations_id })
          .then(( { data } ) => { 
            setInfo(data);
            setLoading(false);
            setError(false);
          })
          .catch(error => {                
            setLoading(false);  
            setError(true);
          });
          
    })
    .catch((error) => {
        console.error('Error en la solicitud:', error);
        setLoading(false);
        setError(true);
    });
    
  }, []);
        
  if (loading) return <><br/><br/><br/><br/><MyLoading /></>;
  if (error) return <center><br /><br/>{translate('public_events.event_not_found')}</center>;
  if (!info || !events) return null;
    
  let address = '';
  address += events.classrooms_name != null ? events.classrooms_name : '';
  address += events.address != null && events.address.length > 0 ? (address.length > 0 ? ', ' : '') + events.address : '';
  address += events.cities_name != null && events.cities_name.length > 0 ? (address.length > 0 ? ', ' : '') + events.cities_name : '';

  const eventCategories = Array.isArray(events.categories)
    ? events.categories
        .map(category => typeof category === 'object' ? category : categories.find(item => Number(item.id) === Number(category)))
        .filter(Boolean)
    : [];
  const eventSessions = Array.isArray(events.sessions) ? events.sessions : [];
  const hasMultipleSessions = eventSessions.length > 1;
                    
  return (
            
    <>
                
      <IconButton onClick={backButtonClick} aria-label={translate('public_events.go_back')} className="public-events-back-button mt-20 ml-20">
      <ArrowBack />
      </IconButton>
        
      <Grid container spacing={2} className="mt-0 pd-5">
        
        { events.images && events.images.length > 0 ? 
          <Grid item xs={12} md={5} textAlign="left" className="pd-5">  
                
            { events.images && events.images.length > 1 ? 
              <Carousel className="events_carrousel_photos" fullHeightHover={true}>
                { events.images.map( (item, i) => <div key={i} className="events_carrousel_item_container"><img src={item} className="events_carrousel_item" title={events.title} alt={events.title || ""} /></div> ) }
              </Carousel>   
              : null }
                
            { events.images && events.images.length === 1 ? 
              <div className="events_carrousel_photos">
                <img src={events.images[0]} className="events_carrousel_item" alt={events.title || ""} />
              </div>
              : null }
                
          </Grid> : null }
            
        <Grid item xs={12} md={ events.images && events.images.length > 0 ? 7 : 12} textAlign="left" className="">  
          {eventCategories.map(category => (
            <Chip key={category.id} label={category.name} variant="outlined" className="bg-orange bc-orange upper mb-10 color-white text-align-left" style={{ marginRight: 3, marginBottom: 3 }} />
          ))}
          <Box display="flex" alignItems="center" className="mb-5">
            <CalendarTodayIcon className="public-events-icon" />
            <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
              {dateEventByLang(events.start,events.end,translate,info.lang)}
            </Typography>
          </Box>
          {!hasMultipleSessions ?
            <Box display="flex" alignItems="center" className="mb-5">
              <AccessTimeIcon className="public-events-icon" />
              <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                {timeEventByLang(events.start,translate,info.lang)}
              </Typography>
            </Box> : null}
                
          { address.length > 0 ? 
            <Box display="flex" alignItems="center" className="mb-5">
              <PlaceIcon className="public-events-icon" />
              <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                {address}
              </Typography>
            </Box> : null }  
                
          <Box display="flex" alignItems="center" className="mb-10">
            <CorporateFareIcon className="public-events-icon" />
            <Typography color="text.secondary" align="justify" className="fs-12 ml-5 upper">
              {events.organizers_name != null ? events.organizers_name : events.associations_name }  
            </Typography>
          </Box> 
          
          <Box display="flex" alignItems="center" className="mb-10">
            <TicketsButton tickets_url={events.tickets_url} />
          </Box>
          
          {/* <Box display="flex" alignItems="center" className="mb-10">
            <TicketsButtonDemo events_id={events.id} />
          </Box> */ }
                
          <Typography gutterBottom variant="h5" component="div" align="left" className="bold">
            {events.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="justify" className="">
            <div className="" spacing={2} dangerouslySetInnerHTML={{ __html: events.description }} />
          </Typography>
        </Grid>

        {hasMultipleSessions ?
          <Grid item xs={12} textAlign="left" className="pd-5 public-event-sessions-container">
            <Typography gutterBottom variant="h6" component="h2" align="left" className="bold">
              {translate('events_sessions.title')}
            </Typography>
            <Box className="public-event-sessions-list">
              {eventSessions.map(session => (
                <Box key={session.id} className="public-event-session-item">
                  {session.name ?
                    <Typography variant="subtitle1" component="h3" align="left" className="bold public-event-session-title">
                      {session.name}
                    </Typography> : null}

                  <Box display="flex" alignItems="center" className="mb-5">
                    <CalendarTodayIcon className="public-events-icon" />
                    <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                      {dateEventByLang(session.start, session.end, translate, info.lang)}
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center" className="mb-5">
                    <AccessTimeIcon className="public-events-icon" />
                    <Typography color="text.secondary" align="justify" className="fs-12 ml-5">
                      {timeEventByLang(session.start, translate, info.lang)}
                    </Typography>
                  </Box>

                </Box>
              ))}
            </Box>
          </Grid> : null}
      </Grid> 
        
    </>
  );
};
   
